import type { UpdateTenantAdmin } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { TenantAdminDto } from './use-tenant-admins.js';

interface UpdateTenantAdminInput {
  clientId: string;
  userOid: string;
  patch: UpdateTenantAdmin;
}

/** Mutation for `PUT /v1/clients/{clientId}/admins/{userOid}` — role change only. */
export function useUpdateTenantAdminMutation(): UseMutationResult<
  TenantAdminDto,
  Error,
  UpdateTenantAdminInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, userOid, patch }: UpdateTenantAdminInput) => {
      if (!api) throw new Error('useUpdateTenantAdminMutation: api client unavailable');
      return api.put<TenantAdminDto>(`/v1/clients/${clientId}/admins/${userOid}`, patch);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['tenant-admins', clientId] });
    },
  });
}
